import { Tooltip } from '@globalmed/atlas-ui';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Wraps a field in a disclaimer tooltip when it's locked for editing
 * (Org Admins can't change Configuration/Provisioning — only GlobalMed
 * Admins can).
 * @param disabled - Whether the field is currently locked.
 * @returns A function that wraps a field element in the disclaimer tooltip
 * when `disabled` is true, or returns it unchanged otherwise.
 */
export const useGlobalMedDisclaimer = (disabled: boolean) => {
  const { t } = useTranslation();

  return (field: ReactElement) =>
    disabled ? (
      <Tooltip
        title={t('admin-panel.provisioning-controlled-by-globalmed')}
        direction="top"
        type="black"
        tail
      >
        {field}
      </Tooltip>
    ) : (
      field
    );
};
